import type { VariantProps } from 'class-variance-authority';
import { ElementType, ReactNode } from 'react';

import * as style from './styles';

export type DisplayInfoCardProps = {
  sections: {
    icon: ElementType;
    title: string;
    cols: VariantProps<typeof style.dataList>['cols'];
    info: string[];
  }[];
  topIcon?: ReactNode;
  onIconClick?: () => void;
};

export function DisplayInfoCard({
  sections,
  topIcon,
  onIconClick,
}: DisplayInfoCardProps) {
  return (
    <div className={style.container()}>
      {topIcon && (
        <div
          className="absolute top-4 right-3 cursor-pointer"
          onClick={onIconClick}
        >
          {topIcon}
        </div>
      )}
      {sections.map(section => {
        const Icon = section.icon;

        return (
          <div key={section.title}>
            <div className={style.header()}>
              <Icon className={style.icon()} strokeWidth={1.5} />
              <p className={style.title()}>{section.title}</p>
            </div>

            <ul
              className={style.dataList({
                cols: section.cols,
              })}
            >
              {section.info
                .filter(item => item)
                .map(item => (
                  <li key={item} className={style.info()}>
                    <span>{item}</span>
                  </li>
                ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
